import type { Verdict } from "./studioTypes"

/**
 * Stakes tiering for stage-3 state transitions, governed by the asymmetry
 * rule: changes that IMPROVE a compliance status get the most scrutiny,
 * because a false "compliant" flows into conformity letters to customers.
 * Ported verbatim from the regulatory-cms studio (src/core/tiers.ts).
 *
 * NOT CMS-bound (user-approved): the scrutiny tiering is review LOGIC, not
 * regulatory content — it stays hardcoded in the UI and is deliberately left
 * out of the regulatory-content centralization.
 */
const RANK: Record<Verdict, number> = {
  compliant: 3,
  compliant_with_conditions: 2,
  pending: 1,
  unknown: 1,
  non_compliant: 0,
}

export function computeTier(prev: Verdict | null, next: Verdict): number {
  if (prev === null) return 3
  if (prev === next) return next === "compliant" ? 1 : 2
  return RANK[next] > RANK[prev] ? 5 : 4
}
